import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { AsideSection } from "../misc/AsideSection";
import type { Contact } from "../types";

// LDF: Protokollgerechte Anschrift und Briefanrede (z. B. „Exzellenz,“) zum Kopieren.

const CopyLine = ({ label, text }: { label: string; text: string }) => {
  const [copied, setCopied] = useState(false);
  return (
    <div className="text-sm">
      <div className="flex items-center justify-between">
        <span className="text-xs text-muted-foreground">{label}</span>
        <button
          type="button"
          title="Kopieren"
          className="text-muted-foreground hover:text-foreground cursor-pointer"
          onClick={() =>
            navigator.clipboard.writeText(text).then(() => {
              setCopied(true);
              setTimeout(() => setCopied(false), 1500);
            })
          }
        >
          {copied ? <Check className="h-3.5 w-3.5 text-green-600" /> : <Copy className="h-3.5 w-3.5" />}
        </button>
      </div>
      <span className="whitespace-pre-line">{text}</span>
    </div>
  );
};

export const ContactSalutation = ({ record }: { record: Contact }) => {
  if (!record.letter_address && !record.salutation) return null;
  return (
    <AsideSection title="Anrede (Protokoll)">
      {record.letter_address && <CopyLine label="Anschrift" text={record.letter_address} />}
      {record.salutation && <CopyLine label="Briefanrede" text={record.salutation} />}
    </AsideSection>
  );
};
